/**
 * Batch 22 service-link map entries.
 *
 * Merged into SERVICE_LINK_MAP at module load.
 * See INTERNAL_LINKING_GUIDE.md for the linking rules.
 */
import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

export const BATCH22_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  // n8n / automation-architecture posts → /n8n-workflow-developer
  "hours-wasted-on-admin-tasks-v2": {
    url: "/n8n-workflow-developer",
    anchor: /n8n workflow integrations/i,
    label: "hire an n8n workflow developer",
  },
  "pay-independent-contractors-philippines-wise-v2": {
    url: "/n8n-workflow-developer",
    anchor: /n8n workflow integrations/i,
    label: "hire an n8n workflow developer",
  },
  "cost-comparison-fte-vs-specialized-va-v2": {
    url: "/n8n-workflow-developer",
    anchor: /n8n workflow integrations/i,
    label: "hire an n8n workflow developer",
  },
  // AI / agentic / voice-AI posts → /voice-ai-vapi-automation
  "how-to-find-ai-savvy-virtual-assistants-philippines-v2": {
    url: "/voice-ai-vapi-automation",
    anchor: /agentic workflows/i,
    label: "hire a Voice AI automation specialist",
  },
  "conversational-ai-voice-agent-integration-specialist-v2": {
    url: "/voice-ai-vapi-automation",
    anchor: /voice agent integration specialist/i,
    label: "hire a Voice AI automation specialist",
  },
  // Hiring / direct-contractor / sourcing posts → homepage (handled by HIRING_TOPIC_SLUGS,
  // not SERVICE_LINK_MAP) — these link to "/" via the runtime hiring link.
};
